import sidebar from '@/config/sidebars/gsc_ga4'
import createVueApp from '@/common/create_app'

Styxie.Initializers.GscGa4Ga4Properties = {
  index: async(props) => {
    const { default: Ga4PropertiesIndex } = await import('@/vue_widgets/gsc_ga4/ga4_properties/index.vue')
    createVueApp(Ga4PropertiesIndex, { props, sidebar })
  }
}
